module.exports = __webpack_public_path__ + "img/alert.68825d4a.svg";